import { render, staticRenderFns } from "./FileTableCustomer.vue?vue&type=template&id=26a4b2d4"
import script from "./FileTableCustomer.vue?vue&type=script&lang=js"
export * from "./FileTableCustomer.vue?vue&type=script&lang=js"
import style0 from "./FileTableCustomer.vue?vue&type=style&index=0&id=26a4b2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports